import React, { useEffect, useState } from 'react';
import PlayListMain from '../Item/PlayListMain';
import PlayListTable from '../Item/PlayListTable';
import {  useHistory, useParams } from 'react-router-dom';
import { db } from '../../firebase';
import Loading from './Loading';


function Song(props) {
    let { id } = useParams();
    const [listSong, setListSong] = useState([]);
    const [songDetail, setSongDetail] = useState({});
    const [loadingPage, setLoadingPage] = useState(true);
    let history = useHistory();

    useEffect(() => {
        if (id) {
            db.collection("songs").where("key" , "==" , `${id}`)
                .get()
                .then(function (doc) {
                    if (!doc.empty) {
                        let song = { id: doc.docs[0].id, ...doc.docs[0].data() };
                        setListSong([song]);
                        setSongDetail(song);
                        setLoadingPage(false);
                    } else {
                        history.push('/error');
                    }
                })
                .catch(function (error) {
                    console.log("Error getting detail song." ,error );
                });

        }
    }, [id]);
    return (
        <div className="Root__right-container__section--wrap-page ">
            <PlayListMain countSongs={listSong.length} countTimes={listSong.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.time), 0)} songDetail={songDetail} type="song" />
            <PlayListTable listSong={listSong} backgroundColor={songDetail.bg_color ? songDetail.bg_color : '#000'} />
            <Loading loadingPage={loadingPage} />
        </div>
    );
}

export default Song;